import { createSlice } from '@reduxjs/toolkit'

/**
 * alert 또는 confirm
 */
export const deviceInfoSlice = createSlice({
	name: 'deviceInfo',
	initialState: {
		info: {
			branchCd: '',
			kioskDeviceId: 0,
			kioskName: '',
			name: '',
			screenNumber: 0,
			screenName: '',
			categoryId: 0,
		},
	},
	reducers: {
		setDeviceInfo: (state, action) => {
			state.info = action.payload
		},
		removeDeviceInfo: (state) => {
			state.info = {
				branchCd: '',
				kioskDeviceId: 0,
				kioskName: '',
				name: '',
				screenNumber: 0,
				screenName: '',
				categoryId: 0,
			}
		},
	},
})

export const { setDeviceInfo, removeDeviceInfo } = deviceInfoSlice.actions
export default deviceInfoSlice.reducer
export const selectDevice = (state: any) => state.deviceInfo.info
